import { Component, ChangeDetectionStrategy } from '@angular/core';
import { GoNavigationComponent } from '../../components/go-navigation/go-navigation.component';
import { AsyncPipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LoadingComponent } from '../../../../../../shared/components/loading/loading.component';
import { LoadingService } from '../../../../../../core/services/loading/loading.service';
import { MasqueradeHeaderComponent } from '../../../../../../shared/components/masquerade-header/masquerade-header.component';
import { GoApplicationPageNavigationComponent } from '../../components/go-application-page-navigation/go-application-page-navigation.component';

@Component({
    selector: 'app-go-base-layout',
    imports: [
        GoNavigationComponent,
        RouterModule,
        LoadingComponent,
        AsyncPipe,
        MasqueradeHeaderComponent,
        GoApplicationPageNavigationComponent,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './go-base-layout.component.html',
})
export class GoBaseLayoutComponent {
    loading$ = this.loadingService.loading$;

    constructor(private readonly loadingService: LoadingService) {}
}
